<template>
  <v-dialog
    v-model="show"
    max-width="400"
    overlay-color="darktext"
    overlay-opacity="0.6"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <!-- eslint-disable vue/no-v-html -->
      <v-card-text v-html="cdText" />
      <v-card-actions class="flex-column  flex-sm-column flex-md-row align-end">
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 mb-2 mb-md-0"
          @click="show=false"
        >
          {{ $t('ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
         
      }
    }
  },
  methods: {
    closeDialog() {
        this.$emit('input', false);
    }
  },
}
</script>